/* tslint:disable */
/* eslint-disable */
/**
 * CGN Onboarding Portal Backoffice
 * Carta Giovani Nazionale Onboarding Portal Backoffice
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Agreement
 */
export interface Agreement {
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'id': string;
    /**
     * 
     * @type {AgreementState}
     * @memberof Agreement
     */
    'state': AgreementState;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'requestDate'?: string;
    /**
     * 
     * @type {Profile}
     * @memberof Agreement
     */
    'profile'?: Profile;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'organizationName'?: string;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof Agreement
     */
    'discounts'?: Array<Discount>;
    /**
     * 
     * @type {Array<Document>}
     * @memberof Agreement
     */
    'documents'?: Array<Document>;
    /**
     * 
     * @type {EntityType}
     * @memberof Agreement
     */
    'entityType'?: EntityType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AgreementState = {
    DraftAgreement: 'DraftAgreement',
    PendingAgreement: 'PendingAgreement',
    AssignedAgreement: 'AssignedAgreement',
    ApprovedAgreement: 'ApprovedAgreement',
    RejectedAgreement: 'RejectedAgreement'
} as const;

export type AgreementState = typeof AgreementState[keyof typeof AgreementState];


/**
 * SendTerminationReminder moves an Approved or Inactive agreement to TerminationReminderSent. StartTerminationInProgress moves TerminationReminderSent to TerminationInProgress. CancelTerminationInProgress moves TerminationInProgress back to TerminationReminderSent. CompleteTermination moves TerminationInProgress to Terminated.
 * @export
 * @enum {string}
 */

export const AgreementTerminationAction = {
    SendTerminationReminder: 'SendTerminationReminder',
    StartTerminationInProgress: 'StartTerminationInProgress',
    CancelTerminationInProgress: 'CancelTerminationInProgress',
    CompleteTermination: 'CompleteTermination'
} as const;

export type AgreementTerminationAction = typeof AgreementTerminationAction[keyof typeof AgreementTerminationAction];


/**
 * 
 * @export
 * @interface AgreementTerminationCommand
 */
export interface AgreementTerminationCommand {
    /**
     * 
     * @type {AgreementTerminationAction}
     * @memberof AgreementTerminationCommand
     */
    'action': AgreementTerminationAction;
}


/**
 * 
 * @export
 * @interface Agreements
 */
export interface Agreements {
    /**
     * 
     * @type {Array<Agreement>}
     * @memberof Agreements
     */
    'items': Array<Agreement>;
    /**
     * 
     * @type {number}
     * @memberof Agreements
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ApprovedAgreement
 */
export interface ApprovedAgreement {
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreement
     */
    'agreementId': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreement
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreement
     */
    'agreementStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreement
     */
    'agreementLastUpdateDate': string;
    /**
     * 
     * @type {ApprovedAgreementState}
     * @memberof ApprovedAgreement
     */
    'state': ApprovedAgreementState;
    /**
     * 
     * @type {number}
     * @memberof ApprovedAgreement
     */
    'publishedDiscounts': number;
    /**
     * 
     * @type {boolean}
     * @memberof ApprovedAgreement
     */
    'testPending': boolean;
    /**
     * 
     * @type {EntityType}
     * @memberof ApprovedAgreement
     */
    'entityType'?: EntityType;
}


/**
 * 
 * @export
 * @interface ApprovedAgreementDetail
 */
export interface ApprovedAgreementDetail {
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDetail
     */
    'agreementId': string;
    /**
     * 
     * @type {ApprovedAgreementState}
     * @memberof ApprovedAgreementDetail
     */
    'state': ApprovedAgreementState;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDetail
     */
    'agreementStateSince'?: string | null;
    /**
     * 
     * @type {ApprovedAgreementProfile}
     * @memberof ApprovedAgreementDetail
     */
    'profile': ApprovedAgreementProfile;
    /**
     * 
     * @type {Array<ApprovedAgreementDiscount>}
     * @memberof ApprovedAgreementDetail
     */
    'discounts'?: Array<ApprovedAgreementDiscount>;
    /**
     * 
     * @type {Array<Document>}
     * @memberof ApprovedAgreementDetail
     */
    'documents': Array<Document>;
}


/**
 * 
 * @export
 * @interface ApprovedAgreementDiscount
 */
export interface ApprovedAgreementDiscount {
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'name_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'name_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'description_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'description_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof ApprovedAgreementDiscount
     */
    'discount'?: number;
    /**
     * 
     * @type {Array<ProductCategory>}
     * @memberof ApprovedAgreementDiscount
     */
    'productCategories': Array<ProductCategory>;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'condition': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'condition_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'condition_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'lastUpateDate': string;
    /**
     * 
     * @type {DiscountState}
     * @memberof ApprovedAgreementDiscount
     */
    'state': DiscountState;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'discountUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'staticCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'eycaLandingPageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'landingPageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'landingPageReferrer'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementDiscount
     */
    'testFailureReason'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApprovedAgreementDiscount
     */
    'visibleOnEyca': boolean;
}


/**
 * 
 * @export
 * @interface ApprovedAgreementProfile
 */
export interface ApprovedAgreementProfile {
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'name_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'name_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'description_en': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'description_de': string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof ApprovedAgreementProfile
     */
    'salesChannel': SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'lastUpateDate': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'taxCodeOrVat': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'pecAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'legalOffice': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'telephoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'legalRepresentativeFullName': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementProfile
     */
    'legalRepresentativeTaxCode': string;
    /**
     * 
     * @type {ApprovedAgreementReferent}
     * @memberof ApprovedAgreementProfile
     */
    'referent': ApprovedAgreementReferent;
    /**
     * 
     * @type {EntityType}
     * @memberof ApprovedAgreementProfile
     */
    'entityType'?: EntityType;
}


/**
 * 
 * @export
 * @interface ApprovedAgreementReferent
 */
export interface ApprovedAgreementReferent {
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementReferent
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementReferent
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementReferent
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementReferent
     */
    'telephoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreementReferent
     */
    'role': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApprovedAgreementState = {
    Approved: 'Approved',
    Active: 'Active',
    Expired: 'Expired',
    Inactive: 'Inactive',
    TerminationReminderSent: 'TerminationReminderSent',
    TerminationInProgress: 'TerminationInProgress',
    Terminated: 'Terminated'
} as const;

export type ApprovedAgreementState = typeof ApprovedAgreementState[keyof typeof ApprovedAgreementState];


/**
 * 
 * @export
 * @interface ApprovedAgreements
 */
export interface ApprovedAgreements {
    /**
     * 
     * @type {Array<ApprovedAgreement>}
     * @memberof ApprovedAgreements
     */
    'items': Array<ApprovedAgreement>;
    /**
     * 
     * @type {number}
     * @memberof ApprovedAgreements
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface AssignedAgreement
 */
export interface AssignedAgreement extends Agreement {
    /**
     * 
     * @type {Assignee}
     * @memberof AssignedAgreement
     */
    'assignee': Assignee;
}


/**
 * 
 * @export
 * @interface Assignee
 */
export interface Assignee {
    /**
     * 
     * @type {string}
     * @memberof Assignee
     */
    'fullName': string;
}
/**
 * 
 * @export
 * @interface BothChannels
 */
export interface BothChannels extends SalesChannel {
    /**
     * 
     * @type {string}
     * @memberof BothChannels
     */
    'websiteUrl': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BothChannels
     */
    'addresses': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BothChannels
     */
    'allNationalAddresses'?: boolean;
    /**
     * 
     * @type {DiscountCodeType}
     * @memberof BothChannels
     */
    'discountCodeType'?: DiscountCodeType;
}


/**
 * 
 * @export
 * @interface BucketCode
 */
export interface BucketCode {
    /**
     * 
     * @type {string}
     * @memberof BucketCode
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface Discount
 */
export interface Discount {
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'agreementId': string;
    /**
     * 
     * @type {DiscountState}
     * @memberof Discount
     */
    'state': DiscountState;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'name_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'name_de'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DiscountCodeType = {
    Static: 'Static',
    Api: 'API',
    LandingPage: 'LandingPage',
    Bucket: 'Bucket'
} as const;

export type DiscountCodeType = typeof DiscountCodeType[keyof typeof DiscountCodeType];


/**
 * 
 * @export
 * @enum {string}
 */

export const DiscountState = {
    Draft: 'draft',
    Published: 'published',
    Suspended: 'suspended',
    Expired: 'expired',
    TestPending: 'test_pending',
    TestPassed: 'test_passed',
    TestFailed: 'test_failed'
} as const;

export type DiscountState = typeof DiscountState[keyof typeof DiscountState];


/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {DocumentType}
     * @memberof Document
     */
    'documentType': DocumentType;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'documentUrl': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'creationDate': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DocumentType = {
    Agreement: 'Agreement',
    AdhesionRequest: 'AdhesionRequest'
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];


/**
 * 
 * @export
 * @interface DraftAgreement
 */
export interface DraftAgreement extends Agreement {
}


/**
 * 
 * @export
 * @enum {string}
 */

export const EntityType = {
    Private: 'Private',
    PublicAdministration: 'PublicAdministration'
} as const;

export type EntityType = typeof EntityType[keyof typeof EntityType];


/**
 * 
 * @export
 * @interface FailureReason
 */
export interface FailureReason {
    /**
     * 
     * @type {string}
     * @memberof FailureReason
     */
    'reasonMessage': string;
}
/**
 * 
 * @export
 * @interface KeyOrganizationFiscalCode
 */
export interface KeyOrganizationFiscalCode {
    /**
     * 
     * @type {string}
     * @memberof KeyOrganizationFiscalCode
     */
    'keyOrganizationFiscalCode': string;
}
/**
 * 
 * @export
 * @interface OfflineChannel
 */
export interface OfflineChannel extends SalesChannel {
    /**
     * 
     * @type {string}
     * @memberof OfflineChannel
     */
    'websiteUrl'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfflineChannel
     */
    'addresses': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof OfflineChannel
     */
    'allNationalAddresses'?: boolean;
}


/**
 * 
 * @export
 * @interface OnlineChannel
 */
export interface OnlineChannel extends SalesChannel {
    /**
     * 
     * @type {string}
     * @memberof OnlineChannel
     */
    'websiteUrl': string;
    /**
     * 
     * @type {DiscountCodeType}
     * @memberof OnlineChannel
     */
    'discountCodeType': DiscountCodeType;
}


/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'organizationFiscalCode': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'pec': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'insertedAt'?: string;
    /**
     * 
     * @type {EntityType}
     * @memberof Organization
     */
    'entityType'?: EntityType;
}


/**
 * 
 * @export
 * @interface OrganizationFiscalCode
 */
export interface OrganizationFiscalCode {
    /**
     * 
     * @type {string}
     * @memberof OrganizationFiscalCode
     */
    'organizationFiscalCode': string;
}
/**
 * 
 * @export
 * @interface OrganizationName
 */
export interface OrganizationName {
    /**
     * 
     * @type {string}
     * @memberof OrganizationName
     */
    'organizationName': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OrganizationStatus = {
    Draft: 'Draft',
    Pending: 'Pending',
    Approved: 'Approved',
    Rejected: 'Rejected',
    Active: 'Active',
    Expired: 'Expired',
    Inactive: 'Inactive',
    TerminationReminderSent: 'TerminationReminderSent',
    TerminationInProgress: 'TerminationInProgress',
    Terminated: 'Terminated'
} as const;

export type OrganizationStatus = typeof OrganizationStatus[keyof typeof OrganizationStatus];


/**
 * 
 * @export
 * @interface OrganizationWithReferents
 */
export interface OrganizationWithReferents {
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithReferents
     */
    'keyOrganizationFiscalCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithReferents
     */
    'organizationFiscalCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithReferents
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithReferents
     */
    'pec': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithReferents
     */
    'insertedAt'?: string;
    /**
     * 
     * @type {EntityType}
     * @memberof OrganizationWithReferents
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationWithReferents
     */
    'referents': Array<string>;
}


/**
 * 
 * @export
 * @interface OrganizationWithReferentsAndStatus
 */
export interface OrganizationWithReferentsAndStatus {
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithReferentsAndStatus
     */
    'keyOrganizationFiscalCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithReferentsAndStatus
     */
    'organizationFiscalCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithReferentsAndStatus
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithReferentsAndStatus
     */
    'pec': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithReferentsAndStatus
     */
    'insertedAt'?: string;
    /**
     * 
     * @type {EntityType}
     * @memberof OrganizationWithReferentsAndStatus
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationWithReferentsAndStatus
     */
    'referents': Array<string>;
    /**
     * 
     * @type {OrganizationStatus}
     * @memberof OrganizationWithReferentsAndStatus
     */
    'status': OrganizationStatus;
}


/**
 * 
 * @export
 * @interface Organizations
 */
export interface Organizations {
    /**
     * 
     * @type {Array<OrganizationWithReferentsAndStatus>}
     * @memberof Organizations
     */
    'items'?: Array<OrganizationWithReferentsAndStatus>;
    /**
     * 
     * @type {number}
     * @memberof Organizations
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface PendingAgreement
 */
export interface PendingAgreement extends Agreement {
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductCategory = {
    BankingServices: 'BankingServices',
    CultureAndEntertainment: 'CultureAndEntertainment',
    Health: 'Health',
    Home: 'Home',
    JobOffers: 'JobOffers',
    Learning: 'Learning',
    Sports: 'Sports',
    SustainableMobility: 'SustainableMobility',
    TelephonyAndInternet: 'TelephonyAndInternet',
    Travelling: 'Travelling'
} as const;

export type ProductCategory = typeof ProductCategory[keyof typeof ProductCategory];


/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'agreementId': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'fullName': string;
    /**
     * 
     * @type {Referent}
     * @memberof Profile
     */
    'referent': Referent;
}
/**
 * 
 * @export
 * @interface Referent
 */
export interface Referent {
    /**
     * 
     * @type {string}
     * @memberof Referent
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof Referent
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof Referent
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof Referent
     */
    'telephoneNumber': string;
}
/**
 * 
 * @export
 * @interface ReferentFiscalCode
 */
export interface ReferentFiscalCode {
    /**
     * 
     * @type {string}
     * @memberof ReferentFiscalCode
     */
    'referentFiscalCode'?: string;
}
/**
 * 
 * @export
 * @interface RefuseAgreement
 */
export interface RefuseAgreement {
    /**
     * 
     * @type {string}
     * @memberof RefuseAgreement
     */
    'reasonMessage': string;
}
/**
 * 
 * @export
 * @interface RejectedAgreement
 */
export interface RejectedAgreement extends Agreement {
    /**
     * 
     * @type {string}
     * @memberof RejectedAgreement
     */
    'reasonMessage': string;
}


/**
 * 
 * @export
 * @interface SalesChannel
 */
export interface SalesChannel {
    /**
     * 
     * @type {SalesChannelType}
     * @memberof SalesChannel
     */
    'channelType': SalesChannelType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SalesChannelType = {
    OnlineChannel: 'OnlineChannel',
    OfflineChannel: 'OfflineChannel',
    BothChannels: 'BothChannels'
} as const;

export type SalesChannelType = typeof SalesChannelType[keyof typeof SalesChannelType];


/**
 * 
 * @export
 * @interface SuspendDiscount
 */
export interface SuspendDiscount {
    /**
     * 
     * @type {string}
     * @memberof SuspendDiscount
     */
    'reasonMessage': string;
}

/**
 * AgreementApi - axios parameter creator
 * @export
 */
export const AgreementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve an agreement
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAgreement: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('approveAgreement', 'agreementId', agreementId)
            const localVarPath = `/agreement-requests/{agreementId}/approval`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign an agreement to the user
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAgreement: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('assignAgreement', 'agreementId', agreementId)
            const localVarPath = `/agreement-requests/{agreementId}/assignee`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of agreements
         * @param {string} [states] Values from &#x60;AgreementState&#x60;
         * @param {GetAgreementsAssigneeEnum} [assignee] Assigned agreement assignee
         * @param {string} [profileFullName] String to search in profile full name
         * @param {string} [requestDateFrom] Agreement request date lower bound
         * @param {string} [requestDateTo] Agreement request date upper bound
         * @param {number} [pageSize] Page size
         * @param {number} [page] Page number
         * @param {GetAgreementsSortColumnEnum} [sortColumn] Sort by column
         * @param {GetAgreementsSortDirectionEnum} [sortDirection] Sort Direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreements: async (states?: string, assignee?: GetAgreementsAssigneeEnum, profileFullName?: string, requestDateFrom?: string, requestDateTo?: string, pageSize?: number, page?: number, sortColumn?: GetAgreementsSortColumnEnum, sortDirection?: GetAgreementsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agreement-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }

            if (assignee !== undefined) {
                localVarQueryParameter['assignee'] = assignee;
            }

            if (profileFullName !== undefined) {
                localVarQueryParameter['profileFullName'] = profileFullName;
            }

            if (requestDateFrom !== undefined) {
                localVarQueryParameter['requestDateFrom'] = (requestDateFrom as any instanceof Date) ?
                    (requestDateFrom as any).toISOString().substring(0,10) :
                    requestDateFrom;
            }

            if (requestDateTo !== undefined) {
                localVarQueryParameter['requestDateTo'] = (requestDateTo as any instanceof Date) ?
                    (requestDateTo as any).toISOString().substring(0,10) :
                    requestDateTo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get agreement in post-approval states
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovedAgreement: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getApprovedAgreement', 'agreementId', agreementId)
            const localVarPath = `/approved-agreements/{agreementId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of agreements in post-approval states
         * @param {string} [profileFullName] String to search in profile full name
         * @param {string} [lastUpdateDateFrom] Agreement last update date lower bound
         * @param {string} [lastUpdateDateTo] Agreement last update date upper bound
         * @param {number} [pageSize] Page size
         * @param {number} [page] Page number
         * @param {GetApprovedAgreementsSortColumnEnum} [sortColumn] Sort by column
         * @param {GetApprovedAgreementsSortDirectionEnum} [sortDirection] Sort Direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovedAgreements: async (profileFullName?: string, lastUpdateDateFrom?: string, lastUpdateDateTo?: string, pageSize?: number, page?: number, sortColumn?: GetApprovedAgreementsSortColumnEnum, sortDirection?: GetApprovedAgreementsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/approved-agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (profileFullName !== undefined) {
                localVarQueryParameter['profileFullName'] = profileFullName;
            }

            if (lastUpdateDateFrom !== undefined) {
                localVarQueryParameter['lastUpdateDateFrom'] = (lastUpdateDateFrom as any instanceof Date) ?
                    (lastUpdateDateFrom as any).toISOString().substring(0,10) :
                    lastUpdateDateFrom;
            }

            if (lastUpdateDateTo !== undefined) {
                localVarQueryParameter['lastUpdateDateTo'] = (lastUpdateDateTo as any instanceof Date) ?
                    (lastUpdateDateTo as any).toISOString().substring(0,10) :
                    lastUpdateDateTo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Execute a post-approval agreement state transition command
         * @param {string} agreementId Agreement id
         * @param {AgreementTerminationCommand} terminationCommand Command to execute on the agreement state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageAgreementTermination: async (agreementId: string, terminationCommand: AgreementTerminationCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('manageAgreementTermination', 'agreementId', agreementId)
            // verify required parameter 'terminationCommand' is not null or undefined
            assertParamExists('manageAgreementTermination', 'terminationCommand', terminationCommand)
            const localVarPath = `/approved-agreements/{agreementId}/termination`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terminationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject an agreement
         * @param {string} agreementId Agreement id
         * @param {RefuseAgreement} refusal Agreement refusal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAgreement: async (agreementId: string, refusal: RefuseAgreement, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('rejectAgreement', 'agreementId', agreementId)
            // verify required parameter 'refusal' is not null or undefined
            assertParamExists('rejectAgreement', 'refusal', refusal)
            const localVarPath = `/agreement-requests/{agreementId}/refusal`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refusal, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unassign an agreement to the user
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignAgreement: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('unassignAgreement', 'agreementId', agreementId)
            const localVarPath = `/agreement-requests/{agreementId}/assignee`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgreementApi - functional programming interface
 * @export
 */
export const AgreementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgreementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve an agreement
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveAgreement(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveAgreement(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.approveAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assign an agreement to the user
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignAgreement(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignAgreement(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.assignAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of agreements
         * @param {string} [states] Values from &#x60;AgreementState&#x60;
         * @param {GetAgreementsAssigneeEnum} [assignee] Assigned agreement assignee
         * @param {string} [profileFullName] String to search in profile full name
         * @param {string} [requestDateFrom] Agreement request date lower bound
         * @param {string} [requestDateTo] Agreement request date upper bound
         * @param {number} [pageSize] Page size
         * @param {number} [page] Page number
         * @param {GetAgreementsSortColumnEnum} [sortColumn] Sort by column
         * @param {GetAgreementsSortDirectionEnum} [sortDirection] Sort Direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreements(states?: string, assignee?: GetAgreementsAssigneeEnum, profileFullName?: string, requestDateFrom?: string, requestDateTo?: string, pageSize?: number, page?: number, sortColumn?: GetAgreementsSortColumnEnum, sortDirection?: GetAgreementsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agreements>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreements(states, assignee, profileFullName, requestDateFrom, requestDateTo, pageSize, page, sortColumn, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getAgreements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get agreement in post-approval states
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApprovedAgreement(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApprovedAgreementDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApprovedAgreement(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getApprovedAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of agreements in post-approval states
         * @param {string} [profileFullName] String to search in profile full name
         * @param {string} [lastUpdateDateFrom] Agreement last update date lower bound
         * @param {string} [lastUpdateDateTo] Agreement last update date upper bound
         * @param {number} [pageSize] Page size
         * @param {number} [page] Page number
         * @param {GetApprovedAgreementsSortColumnEnum} [sortColumn] Sort by column
         * @param {GetApprovedAgreementsSortDirectionEnum} [sortDirection] Sort Direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApprovedAgreements(profileFullName?: string, lastUpdateDateFrom?: string, lastUpdateDateTo?: string, pageSize?: number, page?: number, sortColumn?: GetApprovedAgreementsSortColumnEnum, sortDirection?: GetApprovedAgreementsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApprovedAgreements>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApprovedAgreements(profileFullName, lastUpdateDateFrom, lastUpdateDateTo, pageSize, page, sortColumn, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getApprovedAgreements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Execute a post-approval agreement state transition command
         * @param {string} agreementId Agreement id
         * @param {AgreementTerminationCommand} terminationCommand Command to execute on the agreement state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageAgreementTermination(agreementId: string, terminationCommand: AgreementTerminationCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageAgreementTermination(agreementId, terminationCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.manageAgreementTermination']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject an agreement
         * @param {string} agreementId Agreement id
         * @param {RefuseAgreement} refusal Agreement refusal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectAgreement(agreementId: string, refusal: RefuseAgreement, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectAgreement(agreementId, refusal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.rejectAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unassign an agreement to the user
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignAgreement(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignAgreement(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.unassignAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgreementApi - factory interface
 * @export
 */
export const AgreementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgreementApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve an agreement
         * @param {AgreementApiApproveAgreementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAgreement(requestParameters: AgreementApiApproveAgreementRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveAgreement(requestParameters.agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign an agreement to the user
         * @param {AgreementApiAssignAgreementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAgreement(requestParameters: AgreementApiAssignAgreementRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignAgreement(requestParameters.agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of agreements
         * @param {AgreementApiGetAgreementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreements(requestParameters: AgreementApiGetAgreementsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Agreements> {
            return localVarFp.getAgreements(requestParameters.states, requestParameters.assignee, requestParameters.profileFullName, requestParameters.requestDateFrom, requestParameters.requestDateTo, requestParameters.pageSize, requestParameters.page, requestParameters.sortColumn, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get agreement in post-approval states
         * @param {AgreementApiGetApprovedAgreementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovedAgreement(requestParameters: AgreementApiGetApprovedAgreementRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApprovedAgreementDetail> {
            return localVarFp.getApprovedAgreement(requestParameters.agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of agreements in post-approval states
         * @param {AgreementApiGetApprovedAgreementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovedAgreements(requestParameters: AgreementApiGetApprovedAgreementsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApprovedAgreements> {
            return localVarFp.getApprovedAgreements(requestParameters.profileFullName, requestParameters.lastUpdateDateFrom, requestParameters.lastUpdateDateTo, requestParameters.pageSize, requestParameters.page, requestParameters.sortColumn, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Execute a post-approval agreement state transition command
         * @param {AgreementApiManageAgreementTerminationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageAgreementTermination(requestParameters: AgreementApiManageAgreementTerminationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.manageAgreementTermination(requestParameters.agreementId, requestParameters.terminationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject an agreement
         * @param {AgreementApiRejectAgreementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAgreement(requestParameters: AgreementApiRejectAgreementRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectAgreement(requestParameters.agreementId, requestParameters.refusal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unassign an agreement to the user
         * @param {AgreementApiUnassignAgreementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignAgreement(requestParameters: AgreementApiUnassignAgreementRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unassignAgreement(requestParameters.agreementId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approveAgreement operation in AgreementApi.
 * @export
 * @interface AgreementApiApproveAgreementRequest
 */
export interface AgreementApiApproveAgreementRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof AgreementApiApproveAgreement
     */
    readonly agreementId: string
}

/**
 * Request parameters for assignAgreement operation in AgreementApi.
 * @export
 * @interface AgreementApiAssignAgreementRequest
 */
export interface AgreementApiAssignAgreementRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof AgreementApiAssignAgreement
     */
    readonly agreementId: string
}

/**
 * Request parameters for getAgreements operation in AgreementApi.
 * @export
 * @interface AgreementApiGetAgreementsRequest
 */
export interface AgreementApiGetAgreementsRequest {
    /**
     * Values from &#x60;AgreementState&#x60;
     * @type {string}
     * @memberof AgreementApiGetAgreements
     */
    readonly states?: string

    /**
     * Assigned agreement assignee
     * @type {'Me' | 'Others'}
     * @memberof AgreementApiGetAgreements
     */
    readonly assignee?: GetAgreementsAssigneeEnum

    /**
     * String to search in profile full name
     * @type {string}
     * @memberof AgreementApiGetAgreements
     */
    readonly profileFullName?: string

    /**
     * Agreement request date lower bound
     * @type {string}
     * @memberof AgreementApiGetAgreements
     */
    readonly requestDateFrom?: string

    /**
     * Agreement request date upper bound
     * @type {string}
     * @memberof AgreementApiGetAgreements
     */
    readonly requestDateTo?: string

    /**
     * Page size
     * @type {number}
     * @memberof AgreementApiGetAgreements
     */
    readonly pageSize?: number

    /**
     * Page number
     * @type {number}
     * @memberof AgreementApiGetAgreements
     */
    readonly page?: number

    /**
     * Sort by column
     * @type {'Operator' | 'RequestDate' | 'State' | 'Assignee'}
     * @memberof AgreementApiGetAgreements
     */
    readonly sortColumn?: GetAgreementsSortColumnEnum

    /**
     * Sort Direction
     * @type {'ASC' | 'DESC'}
     * @memberof AgreementApiGetAgreements
     */
    readonly sortDirection?: GetAgreementsSortDirectionEnum
}

/**
 * Request parameters for getApprovedAgreement operation in AgreementApi.
 * @export
 * @interface AgreementApiGetApprovedAgreementRequest
 */
export interface AgreementApiGetApprovedAgreementRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof AgreementApiGetApprovedAgreement
     */
    readonly agreementId: string
}

/**
 * Request parameters for getApprovedAgreements operation in AgreementApi.
 * @export
 * @interface AgreementApiGetApprovedAgreementsRequest
 */
export interface AgreementApiGetApprovedAgreementsRequest {
    /**
     * String to search in profile full name
     * @type {string}
     * @memberof AgreementApiGetApprovedAgreements
     */
    readonly profileFullName?: string

    /**
     * Agreement last update date lower bound
     * @type {string}
     * @memberof AgreementApiGetApprovedAgreements
     */
    readonly lastUpdateDateFrom?: string

    /**
     * Agreement last update date upper bound
     * @type {string}
     * @memberof AgreementApiGetApprovedAgreements
     */
    readonly lastUpdateDateTo?: string

    /**
     * Page size
     * @type {number}
     * @memberof AgreementApiGetApprovedAgreements
     */
    readonly pageSize?: number

    /**
     * Page number
     * @type {number}
     * @memberof AgreementApiGetApprovedAgreements
     */
    readonly page?: number

    /**
     * Sort by column
     * @type {'Operator' | 'AgreementDate' | 'LastModifyDate' | 'PublishedDiscounts' | 'Test' | 'State'}
     * @memberof AgreementApiGetApprovedAgreements
     */
    readonly sortColumn?: GetApprovedAgreementsSortColumnEnum

    /**
     * Sort Direction
     * @type {'ASC' | 'DESC'}
     * @memberof AgreementApiGetApprovedAgreements
     */
    readonly sortDirection?: GetApprovedAgreementsSortDirectionEnum
}

/**
 * Request parameters for manageAgreementTermination operation in AgreementApi.
 * @export
 * @interface AgreementApiManageAgreementTerminationRequest
 */
export interface AgreementApiManageAgreementTerminationRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof AgreementApiManageAgreementTermination
     */
    readonly agreementId: string

    /**
     * Command to execute on the agreement state
     * @type {AgreementTerminationCommand}
     * @memberof AgreementApiManageAgreementTermination
     */
    readonly terminationCommand: AgreementTerminationCommand
}

/**
 * Request parameters for rejectAgreement operation in AgreementApi.
 * @export
 * @interface AgreementApiRejectAgreementRequest
 */
export interface AgreementApiRejectAgreementRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof AgreementApiRejectAgreement
     */
    readonly agreementId: string

    /**
     * Agreement refusal
     * @type {RefuseAgreement}
     * @memberof AgreementApiRejectAgreement
     */
    readonly refusal: RefuseAgreement
}

/**
 * Request parameters for unassignAgreement operation in AgreementApi.
 * @export
 * @interface AgreementApiUnassignAgreementRequest
 */
export interface AgreementApiUnassignAgreementRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof AgreementApiUnassignAgreement
     */
    readonly agreementId: string
}

/**
 * AgreementApi - object-oriented interface
 * @export
 * @class AgreementApi
 * @extends {BaseAPI}
 */
export class AgreementApi extends BaseAPI {
    /**
     * 
     * @summary Approve an agreement
     * @param {AgreementApiApproveAgreementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public approveAgreement(requestParameters: AgreementApiApproveAgreementRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).approveAgreement(requestParameters.agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign an agreement to the user
     * @param {AgreementApiAssignAgreementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public assignAgreement(requestParameters: AgreementApiAssignAgreementRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).assignAgreement(requestParameters.agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of agreements
     * @param {AgreementApiGetAgreementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getAgreements(requestParameters: AgreementApiGetAgreementsRequest = {}, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getAgreements(requestParameters.states, requestParameters.assignee, requestParameters.profileFullName, requestParameters.requestDateFrom, requestParameters.requestDateTo, requestParameters.pageSize, requestParameters.page, requestParameters.sortColumn, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get agreement in post-approval states
     * @param {AgreementApiGetApprovedAgreementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getApprovedAgreement(requestParameters: AgreementApiGetApprovedAgreementRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getApprovedAgreement(requestParameters.agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of agreements in post-approval states
     * @param {AgreementApiGetApprovedAgreementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getApprovedAgreements(requestParameters: AgreementApiGetApprovedAgreementsRequest = {}, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getApprovedAgreements(requestParameters.profileFullName, requestParameters.lastUpdateDateFrom, requestParameters.lastUpdateDateTo, requestParameters.pageSize, requestParameters.page, requestParameters.sortColumn, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Execute a post-approval agreement state transition command
     * @param {AgreementApiManageAgreementTerminationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public manageAgreementTermination(requestParameters: AgreementApiManageAgreementTerminationRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).manageAgreementTermination(requestParameters.agreementId, requestParameters.terminationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject an agreement
     * @param {AgreementApiRejectAgreementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public rejectAgreement(requestParameters: AgreementApiRejectAgreementRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).rejectAgreement(requestParameters.agreementId, requestParameters.refusal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unassign an agreement to the user
     * @param {AgreementApiUnassignAgreementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public unassignAgreement(requestParameters: AgreementApiUnassignAgreementRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).unassignAgreement(requestParameters.agreementId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAgreementsAssigneeEnum = {
    Me: 'Me',
    Others: 'Others'
} as const;
export type GetAgreementsAssigneeEnum = typeof GetAgreementsAssigneeEnum[keyof typeof GetAgreementsAssigneeEnum];
/**
 * @export
 */
export const GetAgreementsSortColumnEnum = {
    Operator: 'Operator',
    RequestDate: 'RequestDate',
    State: 'State',
    Assignee: 'Assignee'
} as const;
export type GetAgreementsSortColumnEnum = typeof GetAgreementsSortColumnEnum[keyof typeof GetAgreementsSortColumnEnum];
/**
 * @export
 */
export const GetAgreementsSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetAgreementsSortDirectionEnum = typeof GetAgreementsSortDirectionEnum[keyof typeof GetAgreementsSortDirectionEnum];
/**
 * @export
 */
export const GetApprovedAgreementsSortColumnEnum = {
    Operator: 'Operator',
    AgreementDate: 'AgreementDate',
    LastModifyDate: 'LastModifyDate',
    PublishedDiscounts: 'PublishedDiscounts',
    Test: 'Test',
    State: 'State'
} as const;
export type GetApprovedAgreementsSortColumnEnum = typeof GetApprovedAgreementsSortColumnEnum[keyof typeof GetApprovedAgreementsSortColumnEnum];
/**
 * @export
 */
export const GetApprovedAgreementsSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetApprovedAgreementsSortDirectionEnum = typeof GetApprovedAgreementsSortDirectionEnum[keyof typeof GetApprovedAgreementsSortDirectionEnum];


/**
 * AttributeauthorityApi - axios parameter creator
 * @export
 */
export const AttributeauthorityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete an organization
         * @summary Delete organization.
         * @param {string} keyOrganizationFiscalCode Organization fiscal code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization: async (keyOrganizationFiscalCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyOrganizationFiscalCode' is not null or undefined
            assertParamExists('deleteOrganization', 'keyOrganizationFiscalCode', keyOrganizationFiscalCode)
            const localVarPath = `/organization/{keyOrganizationFiscalCode}`
                .replace(`{${"keyOrganizationFiscalCode"}}`, encodeURIComponent(String(keyOrganizationFiscalCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a referent
         * @summary Delete referent.
         * @param {string} keyOrganizationFiscalCode Organization fiscal code
         * @param {string} referentFiscalCode Referent fiscal code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReferent: async (keyOrganizationFiscalCode: string, referentFiscalCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyOrganizationFiscalCode' is not null or undefined
            assertParamExists('deleteReferent', 'keyOrganizationFiscalCode', keyOrganizationFiscalCode)
            // verify required parameter 'referentFiscalCode' is not null or undefined
            assertParamExists('deleteReferent', 'referentFiscalCode', referentFiscalCode)
            const localVarPath = `/organization/{keyOrganizationFiscalCode}/referents/{referentFiscalCode}`
                .replace(`{${"keyOrganizationFiscalCode"}}`, encodeURIComponent(String(keyOrganizationFiscalCode)))
                .replace(`{${"referentFiscalCode"}}`, encodeURIComponent(String(referentFiscalCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an organization by fiscal code
         * @summary Get organization
         * @param {string} keyOrganizationFiscalCode Organization fiscal code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization: async (keyOrganizationFiscalCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyOrganizationFiscalCode' is not null or undefined
            assertParamExists('getOrganization', 'keyOrganizationFiscalCode', keyOrganizationFiscalCode)
            const localVarPath = `/organization/{keyOrganizationFiscalCode}`
                .replace(`{${"keyOrganizationFiscalCode"}}`, encodeURIComponent(String(keyOrganizationFiscalCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all organizations
         * @summary Get organizations
         * @param {string} [searchQuery] String to search in organization name o fiscal code
         * @param {number} [page] Page number
         * @param {number} [pageSize] Page size
         * @param {GetOrganizationsSortByEnum} [sortBy] The field to sort by
         * @param {GetOrganizationsSortDirectionEnum} [sortDirection] Sort Direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations: async (searchQuery?: string, page?: number, pageSize?: number, sortBy?: GetOrganizationsSortByEnum, sortDirection?: GetOrganizationsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all referents for a organization
         * @summary Get referents
         * @param {string} keyOrganizationFiscalCode Organization fiscal code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferents: async (keyOrganizationFiscalCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyOrganizationFiscalCode' is not null or undefined
            assertParamExists('getReferents', 'keyOrganizationFiscalCode', keyOrganizationFiscalCode)
            const localVarPath = `/organization/{keyOrganizationFiscalCode}/referents`
                .replace(`{${"keyOrganizationFiscalCode"}}`, encodeURIComponent(String(keyOrganizationFiscalCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Insert a referent fiscalcode.
         * @summary Insert referent.
         * @param {string} keyOrganizationFiscalCode Organization fiscal code
         * @param {ReferentFiscalCode} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertReferent: async (keyOrganizationFiscalCode: string, body: ReferentFiscalCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyOrganizationFiscalCode' is not null or undefined
            assertParamExists('insertReferent', 'keyOrganizationFiscalCode', keyOrganizationFiscalCode)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('insertReferent', 'body', body)
            const localVarPath = `/organization/{keyOrganizationFiscalCode}/referents`
                .replace(`{${"keyOrganizationFiscalCode"}}`, encodeURIComponent(String(keyOrganizationFiscalCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update or insert an organization.
         * @summary Upsert organization.
         * @param {OrganizationWithReferents} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOrganization: async (body?: OrganizationWithReferents, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttributeauthorityApi - functional programming interface
 * @export
 */
export const AttributeauthorityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttributeauthorityApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete an organization
         * @summary Delete organization.
         * @param {string} keyOrganizationFiscalCode Organization fiscal code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganization(keyOrganizationFiscalCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganization(keyOrganizationFiscalCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributeauthorityApi.deleteOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a referent
         * @summary Delete referent.
         * @param {string} keyOrganizationFiscalCode Organization fiscal code
         * @param {string} referentFiscalCode Referent fiscal code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReferent(keyOrganizationFiscalCode: string, referentFiscalCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReferent(keyOrganizationFiscalCode, referentFiscalCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributeauthorityApi.deleteReferent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an organization by fiscal code
         * @summary Get organization
         * @param {string} keyOrganizationFiscalCode Organization fiscal code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganization(keyOrganizationFiscalCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationWithReferentsAndStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganization(keyOrganizationFiscalCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributeauthorityApi.getOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all organizations
         * @summary Get organizations
         * @param {string} [searchQuery] String to search in organization name o fiscal code
         * @param {number} [page] Page number
         * @param {number} [pageSize] Page size
         * @param {GetOrganizationsSortByEnum} [sortBy] The field to sort by
         * @param {GetOrganizationsSortDirectionEnum} [sortDirection] Sort Direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizations(searchQuery?: string, page?: number, pageSize?: number, sortBy?: GetOrganizationsSortByEnum, sortDirection?: GetOrganizationsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organizations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizations(searchQuery, page, pageSize, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributeauthorityApi.getOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all referents for a organization
         * @summary Get referents
         * @param {string} keyOrganizationFiscalCode Organization fiscal code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferents(keyOrganizationFiscalCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferents(keyOrganizationFiscalCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributeauthorityApi.getReferents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Insert a referent fiscalcode.
         * @summary Insert referent.
         * @param {string} keyOrganizationFiscalCode Organization fiscal code
         * @param {ReferentFiscalCode} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertReferent(keyOrganizationFiscalCode: string, body: ReferentFiscalCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertReferent(keyOrganizationFiscalCode, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributeauthorityApi.insertReferent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update or insert an organization.
         * @summary Upsert organization.
         * @param {OrganizationWithReferents} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertOrganization(body?: OrganizationWithReferents, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationWithReferents>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertOrganization(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributeauthorityApi.upsertOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AttributeauthorityApi - factory interface
 * @export
 */
export const AttributeauthorityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttributeauthorityApiFp(configuration)
    return {
        /**
         * Delete an organization
         * @summary Delete organization.
         * @param {AttributeauthorityApiDeleteOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization(requestParameters: AttributeauthorityApiDeleteOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrganization(requestParameters.keyOrganizationFiscalCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a referent
         * @summary Delete referent.
         * @param {AttributeauthorityApiDeleteReferentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReferent(requestParameters: AttributeauthorityApiDeleteReferentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteReferent(requestParameters.keyOrganizationFiscalCode, requestParameters.referentFiscalCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an organization by fiscal code
         * @summary Get organization
         * @param {AttributeauthorityApiGetOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization(requestParameters: AttributeauthorityApiGetOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationWithReferentsAndStatus> {
            return localVarFp.getOrganization(requestParameters.keyOrganizationFiscalCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all organizations
         * @summary Get organizations
         * @param {AttributeauthorityApiGetOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations(requestParameters: AttributeauthorityApiGetOrganizationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Organizations> {
            return localVarFp.getOrganizations(requestParameters.searchQuery, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all referents for a organization
         * @summary Get referents
         * @param {AttributeauthorityApiGetReferentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferents(requestParameters: AttributeauthorityApiGetReferentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getReferents(requestParameters.keyOrganizationFiscalCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Insert a referent fiscalcode.
         * @summary Insert referent.
         * @param {AttributeauthorityApiInsertReferentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertReferent(requestParameters: AttributeauthorityApiInsertReferentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.insertReferent(requestParameters.keyOrganizationFiscalCode, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * Update or insert an organization.
         * @summary Upsert organization.
         * @param {AttributeauthorityApiUpsertOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOrganization(requestParameters: AttributeauthorityApiUpsertOrganizationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationWithReferents> {
            return localVarFp.upsertOrganization(requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteOrganization operation in AttributeauthorityApi.
 * @export
 * @interface AttributeauthorityApiDeleteOrganizationRequest
 */
export interface AttributeauthorityApiDeleteOrganizationRequest {
    /**
     * Organization fiscal code
     * @type {string}
     * @memberof AttributeauthorityApiDeleteOrganization
     */
    readonly keyOrganizationFiscalCode: string
}

/**
 * Request parameters for deleteReferent operation in AttributeauthorityApi.
 * @export
 * @interface AttributeauthorityApiDeleteReferentRequest
 */
export interface AttributeauthorityApiDeleteReferentRequest {
    /**
     * Organization fiscal code
     * @type {string}
     * @memberof AttributeauthorityApiDeleteReferent
     */
    readonly keyOrganizationFiscalCode: string

    /**
     * Referent fiscal code
     * @type {string}
     * @memberof AttributeauthorityApiDeleteReferent
     */
    readonly referentFiscalCode: string
}

/**
 * Request parameters for getOrganization operation in AttributeauthorityApi.
 * @export
 * @interface AttributeauthorityApiGetOrganizationRequest
 */
export interface AttributeauthorityApiGetOrganizationRequest {
    /**
     * Organization fiscal code
     * @type {string}
     * @memberof AttributeauthorityApiGetOrganization
     */
    readonly keyOrganizationFiscalCode: string
}

/**
 * Request parameters for getOrganizations operation in AttributeauthorityApi.
 * @export
 * @interface AttributeauthorityApiGetOrganizationsRequest
 */
export interface AttributeauthorityApiGetOrganizationsRequest {
    /**
     * String to search in organization name o fiscal code
     * @type {string}
     * @memberof AttributeauthorityApiGetOrganizations
     */
    readonly searchQuery?: string

    /**
     * Page number
     * @type {number}
     * @memberof AttributeauthorityApiGetOrganizations
     */
    readonly page?: number

    /**
     * Page size
     * @type {number}
     * @memberof AttributeauthorityApiGetOrganizations
     */
    readonly pageSize?: number

    /**
     * The field to sort by
     * @type {'fiscalCode' | 'name' | 'pec' | 'insertedAt'}
     * @memberof AttributeauthorityApiGetOrganizations
     */
    readonly sortBy?: GetOrganizationsSortByEnum

    /**
     * Sort Direction
     * @type {'ASC' | 'DESC'}
     * @memberof AttributeauthorityApiGetOrganizations
     */
    readonly sortDirection?: GetOrganizationsSortDirectionEnum
}

/**
 * Request parameters for getReferents operation in AttributeauthorityApi.
 * @export
 * @interface AttributeauthorityApiGetReferentsRequest
 */
export interface AttributeauthorityApiGetReferentsRequest {
    /**
     * Organization fiscal code
     * @type {string}
     * @memberof AttributeauthorityApiGetReferents
     */
    readonly keyOrganizationFiscalCode: string
}

/**
 * Request parameters for insertReferent operation in AttributeauthorityApi.
 * @export
 * @interface AttributeauthorityApiInsertReferentRequest
 */
export interface AttributeauthorityApiInsertReferentRequest {
    /**
     * Organization fiscal code
     * @type {string}
     * @memberof AttributeauthorityApiInsertReferent
     */
    readonly keyOrganizationFiscalCode: string

    /**
     * 
     * @type {ReferentFiscalCode}
     * @memberof AttributeauthorityApiInsertReferent
     */
    readonly body: ReferentFiscalCode
}

/**
 * Request parameters for upsertOrganization operation in AttributeauthorityApi.
 * @export
 * @interface AttributeauthorityApiUpsertOrganizationRequest
 */
export interface AttributeauthorityApiUpsertOrganizationRequest {
    /**
     * 
     * @type {OrganizationWithReferents}
     * @memberof AttributeauthorityApiUpsertOrganization
     */
    readonly body?: OrganizationWithReferents
}

/**
 * AttributeauthorityApi - object-oriented interface
 * @export
 * @class AttributeauthorityApi
 * @extends {BaseAPI}
 */
export class AttributeauthorityApi extends BaseAPI {
    /**
     * Delete an organization
     * @summary Delete organization.
     * @param {AttributeauthorityApiDeleteOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeauthorityApi
     */
    public deleteOrganization(requestParameters: AttributeauthorityApiDeleteOrganizationRequest, options?: RawAxiosRequestConfig) {
        return AttributeauthorityApiFp(this.configuration).deleteOrganization(requestParameters.keyOrganizationFiscalCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a referent
     * @summary Delete referent.
     * @param {AttributeauthorityApiDeleteReferentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeauthorityApi
     */
    public deleteReferent(requestParameters: AttributeauthorityApiDeleteReferentRequest, options?: RawAxiosRequestConfig) {
        return AttributeauthorityApiFp(this.configuration).deleteReferent(requestParameters.keyOrganizationFiscalCode, requestParameters.referentFiscalCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an organization by fiscal code
     * @summary Get organization
     * @param {AttributeauthorityApiGetOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeauthorityApi
     */
    public getOrganization(requestParameters: AttributeauthorityApiGetOrganizationRequest, options?: RawAxiosRequestConfig) {
        return AttributeauthorityApiFp(this.configuration).getOrganization(requestParameters.keyOrganizationFiscalCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all organizations
     * @summary Get organizations
     * @param {AttributeauthorityApiGetOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeauthorityApi
     */
    public getOrganizations(requestParameters: AttributeauthorityApiGetOrganizationsRequest = {}, options?: RawAxiosRequestConfig) {
        return AttributeauthorityApiFp(this.configuration).getOrganizations(requestParameters.searchQuery, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all referents for a organization
     * @summary Get referents
     * @param {AttributeauthorityApiGetReferentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeauthorityApi
     */
    public getReferents(requestParameters: AttributeauthorityApiGetReferentsRequest, options?: RawAxiosRequestConfig) {
        return AttributeauthorityApiFp(this.configuration).getReferents(requestParameters.keyOrganizationFiscalCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Insert a referent fiscalcode.
     * @summary Insert referent.
     * @param {AttributeauthorityApiInsertReferentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeauthorityApi
     */
    public insertReferent(requestParameters: AttributeauthorityApiInsertReferentRequest, options?: RawAxiosRequestConfig) {
        return AttributeauthorityApiFp(this.configuration).insertReferent(requestParameters.keyOrganizationFiscalCode, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update or insert an organization.
     * @summary Upsert organization.
     * @param {AttributeauthorityApiUpsertOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeauthorityApi
     */
    public upsertOrganization(requestParameters: AttributeauthorityApiUpsertOrganizationRequest = {}, options?: RawAxiosRequestConfig) {
        return AttributeauthorityApiFp(this.configuration).upsertOrganization(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetOrganizationsSortByEnum = {
    FiscalCode: 'fiscalCode',
    Name: 'name',
    Pec: 'pec',
    InsertedAt: 'insertedAt'
} as const;
export type GetOrganizationsSortByEnum = typeof GetOrganizationsSortByEnum[keyof typeof GetOrganizationsSortByEnum];
/**
 * @export
 */
export const GetOrganizationsSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetOrganizationsSortDirectionEnum = typeof GetOrganizationsSortDirectionEnum[keyof typeof GetOrganizationsSortDirectionEnum];


/**
 * DiscountApi - axios parameter creator
 * @export
 */
export const DiscountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a bucket code for discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountBucketCode: async (agreementId: string, discountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getDiscountBucketCode', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('getDiscountBucketCode', 'discountId', discountId)
            const localVarPath = `/agreement-requests/{agreementId}/discounts/{discountId}/bucket-code`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark as test failed with a reason
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {FailureReason} failure Failure reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDiscountTestFailed: async (agreementId: string, discountId: string, failure: FailureReason, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('setDiscountTestFailed', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('setDiscountTestFailed', 'discountId', discountId)
            // verify required parameter 'failure' is not null or undefined
            assertParamExists('setDiscountTestFailed', 'failure', failure)
            const localVarPath = `/agreement-requests/{agreementId}/discounts/{discountId}/test-failed`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(failure, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark as test passed
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDiscountTestPassed: async (agreementId: string, discountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('setDiscountTestPassed', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('setDiscountTestPassed', 'discountId', discountId)
            const localVarPath = `/agreement-requests/{agreementId}/discounts/{discountId}/test-passed`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suspend a discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {SuspendDiscount} suspension Discount suspension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendDiscount: async (agreementId: string, discountId: string, suspension: SuspendDiscount, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('suspendDiscount', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('suspendDiscount', 'discountId', discountId)
            // verify required parameter 'suspension' is not null or undefined
            assertParamExists('suspendDiscount', 'suspension', suspension)
            const localVarPath = `/agreement-requests/{agreementId}/discounts/{discountId}/suspension`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(suspension, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscountApi - functional programming interface
 * @export
 */
export const DiscountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiscountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a bucket code for discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscountBucketCode(agreementId: string, discountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BucketCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscountBucketCode(agreementId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.getDiscountBucketCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark as test failed with a reason
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {FailureReason} failure Failure reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDiscountTestFailed(agreementId: string, discountId: string, failure: FailureReason, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDiscountTestFailed(agreementId, discountId, failure, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.setDiscountTestFailed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark as test passed
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDiscountTestPassed(agreementId: string, discountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDiscountTestPassed(agreementId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.setDiscountTestPassed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suspend a discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {SuspendDiscount} suspension Discount suspension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendDiscount(agreementId: string, discountId: string, suspension: SuspendDiscount, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendDiscount(agreementId, discountId, suspension, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.suspendDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiscountApi - factory interface
 * @export
 */
export const DiscountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiscountApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a bucket code for discount
         * @param {DiscountApiGetDiscountBucketCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountBucketCode(requestParameters: DiscountApiGetDiscountBucketCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<BucketCode> {
            return localVarFp.getDiscountBucketCode(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark as test failed with a reason
         * @param {DiscountApiSetDiscountTestFailedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDiscountTestFailed(requestParameters: DiscountApiSetDiscountTestFailedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDiscountTestFailed(requestParameters.agreementId, requestParameters.discountId, requestParameters.failure, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark as test passed
         * @param {DiscountApiSetDiscountTestPassedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDiscountTestPassed(requestParameters: DiscountApiSetDiscountTestPassedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDiscountTestPassed(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suspend a discount
         * @param {DiscountApiSuspendDiscountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendDiscount(requestParameters: DiscountApiSuspendDiscountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suspendDiscount(requestParameters.agreementId, requestParameters.discountId, requestParameters.suspension, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDiscountBucketCode operation in DiscountApi.
 * @export
 * @interface DiscountApiGetDiscountBucketCodeRequest
 */
export interface DiscountApiGetDiscountBucketCodeRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiGetDiscountBucketCode
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountApiGetDiscountBucketCode
     */
    readonly discountId: string
}

/**
 * Request parameters for setDiscountTestFailed operation in DiscountApi.
 * @export
 * @interface DiscountApiSetDiscountTestFailedRequest
 */
export interface DiscountApiSetDiscountTestFailedRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiSetDiscountTestFailed
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountApiSetDiscountTestFailed
     */
    readonly discountId: string

    /**
     * Failure reason
     * @type {FailureReason}
     * @memberof DiscountApiSetDiscountTestFailed
     */
    readonly failure: FailureReason
}

/**
 * Request parameters for setDiscountTestPassed operation in DiscountApi.
 * @export
 * @interface DiscountApiSetDiscountTestPassedRequest
 */
export interface DiscountApiSetDiscountTestPassedRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiSetDiscountTestPassed
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountApiSetDiscountTestPassed
     */
    readonly discountId: string
}

/**
 * Request parameters for suspendDiscount operation in DiscountApi.
 * @export
 * @interface DiscountApiSuspendDiscountRequest
 */
export interface DiscountApiSuspendDiscountRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiSuspendDiscount
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountApiSuspendDiscount
     */
    readonly discountId: string

    /**
     * Discount suspension
     * @type {SuspendDiscount}
     * @memberof DiscountApiSuspendDiscount
     */
    readonly suspension: SuspendDiscount
}

/**
 * DiscountApi - object-oriented interface
 * @export
 * @class DiscountApi
 * @extends {BaseAPI}
 */
export class DiscountApi extends BaseAPI {
    /**
     * 
     * @summary Get a bucket code for discount
     * @param {DiscountApiGetDiscountBucketCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public getDiscountBucketCode(requestParameters: DiscountApiGetDiscountBucketCodeRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).getDiscountBucketCode(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark as test failed with a reason
     * @param {DiscountApiSetDiscountTestFailedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public setDiscountTestFailed(requestParameters: DiscountApiSetDiscountTestFailedRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).setDiscountTestFailed(requestParameters.agreementId, requestParameters.discountId, requestParameters.failure, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark as test passed
     * @param {DiscountApiSetDiscountTestPassedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public setDiscountTestPassed(requestParameters: DiscountApiSetDiscountTestPassedRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).setDiscountTestPassed(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suspend a discount
     * @param {DiscountApiSuspendDiscountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public suspendDiscount(requestParameters: DiscountApiSuspendDiscountRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).suspendDiscount(requestParameters.agreementId, requestParameters.discountId, requestParameters.suspension, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a document
         * @param {string} agreementId Agreement id
         * @param {DeleteDocumentDocumentTypeEnum} documentType Document type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (agreementId: string, documentType: DeleteDocumentDocumentTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('deleteDocument', 'agreementId', agreementId)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('deleteDocument', 'documentType', documentType)
            const localVarPath = `/agreement-requests/{agreementId}/documents/{documentType}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get documents
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getDocuments', 'agreementId', agreementId)
            const localVarPath = `/agreement-requests/{agreementId}/documents`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a document
         * @param {string} agreementId Agreement id
         * @param {UploadDocumentDocumentTypeEnum} documentType Document type
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument: async (agreementId: string, documentType: UploadDocumentDocumentTypeEnum, document: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('uploadDocument', 'agreementId', agreementId)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('uploadDocument', 'documentType', documentType)
            // verify required parameter 'document' is not null or undefined
            assertParamExists('uploadDocument', 'document', document)
            const localVarPath = `/agreement-requests/{agreementId}/documents/{documentType}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (document !== undefined) { 
                localVarFormParams.append('document', document as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a document
         * @param {string} agreementId Agreement id
         * @param {DeleteDocumentDocumentTypeEnum} documentType Document type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument(agreementId: string, documentType: DeleteDocumentDocumentTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(agreementId, documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.deleteDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get documents
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocuments(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Document>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.getDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a document
         * @param {string} agreementId Agreement id
         * @param {UploadDocumentDocumentTypeEnum} documentType Document type
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocument(agreementId: string, documentType: UploadDocumentDocumentTypeEnum, document: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocument(agreementId, documentType, document, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.uploadDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a document
         * @param {DocumentApiDeleteDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(requestParameters: DocumentApiDeleteDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDocument(requestParameters.agreementId, requestParameters.documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get documents
         * @param {DocumentApiGetDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(requestParameters: DocumentApiGetDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Document>> {
            return localVarFp.getDocuments(requestParameters.agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a document
         * @param {DocumentApiUploadDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument(requestParameters: DocumentApiUploadDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.uploadDocument(requestParameters.agreementId, requestParameters.documentType, requestParameters.document, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteDocument operation in DocumentApi.
 * @export
 * @interface DocumentApiDeleteDocumentRequest
 */
export interface DocumentApiDeleteDocumentRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DocumentApiDeleteDocument
     */
    readonly agreementId: string

    /**
     * Document type
     * @type {'Agreement' | 'AdhesionRequest'}
     * @memberof DocumentApiDeleteDocument
     */
    readonly documentType: DeleteDocumentDocumentTypeEnum
}

/**
 * Request parameters for getDocuments operation in DocumentApi.
 * @export
 * @interface DocumentApiGetDocumentsRequest
 */
export interface DocumentApiGetDocumentsRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DocumentApiGetDocuments
     */
    readonly agreementId: string
}

/**
 * Request parameters for uploadDocument operation in DocumentApi.
 * @export
 * @interface DocumentApiUploadDocumentRequest
 */
export interface DocumentApiUploadDocumentRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DocumentApiUploadDocument
     */
    readonly agreementId: string

    /**
     * Document type
     * @type {'Agreement' | 'AdhesionRequest'}
     * @memberof DocumentApiUploadDocument
     */
    readonly documentType: UploadDocumentDocumentTypeEnum

    /**
     * 
     * @type {File}
     * @memberof DocumentApiUploadDocument
     */
    readonly document: File
}

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @summary Delete a document
     * @param {DocumentApiDeleteDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public deleteDocument(requestParameters: DocumentApiDeleteDocumentRequest, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).deleteDocument(requestParameters.agreementId, requestParameters.documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get documents
     * @param {DocumentApiGetDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocuments(requestParameters: DocumentApiGetDocumentsRequest, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).getDocuments(requestParameters.agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a document
     * @param {DocumentApiUploadDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public uploadDocument(requestParameters: DocumentApiUploadDocumentRequest, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).uploadDocument(requestParameters.agreementId, requestParameters.documentType, requestParameters.document, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DeleteDocumentDocumentTypeEnum = {
    Agreement: 'Agreement',
    AdhesionRequest: 'AdhesionRequest'
} as const;
export type DeleteDocumentDocumentTypeEnum = typeof DeleteDocumentDocumentTypeEnum[keyof typeof DeleteDocumentDocumentTypeEnum];
/**
 * @export
 */
export const UploadDocumentDocumentTypeEnum = {
    Agreement: 'Agreement',
    AdhesionRequest: 'AdhesionRequest'
} as const;
export type UploadDocumentDocumentTypeEnum = typeof UploadDocumentDocumentTypeEnum[keyof typeof UploadDocumentDocumentTypeEnum];


/**
 * ExportsApi - axios parameter creator
 * @export
 */
export const ExportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download an export of agreements in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAgreements: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/export/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download an export of eyca discounts in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEycaDiscounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/export/eyca-discounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportsApi - functional programming interface
 * @export
 */
export const ExportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download an export of agreements in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAgreements(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAgreements(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportsApi.exportAgreements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download an export of eyca discounts in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEycaDiscounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportEycaDiscounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportsApi.exportEycaDiscounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExportsApi - factory interface
 * @export
 */
export const ExportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Download an export of agreements in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAgreements(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportAgreements(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download an export of eyca discounts in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEycaDiscounts(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportEycaDiscounts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportsApi - object-oriented interface
 * @export
 * @class ExportsApi
 * @extends {BaseAPI}
 */
export class ExportsApi extends BaseAPI {
    /**
     * 
     * @summary Download an export of agreements in CSV format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportsApi
     */
    public exportAgreements(options?: RawAxiosRequestConfig) {
        return ExportsApiFp(this.configuration).exportAgreements(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download an export of eyca discounts in CSV format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportsApi
     */
    public exportEycaDiscounts(options?: RawAxiosRequestConfig) {
        return ExportsApiFp(this.configuration).exportEycaDiscounts(options).then((request) => request(this.axios, this.basePath));
    }
}



